export const OPTION_THRESHOLD = 5;

/**
 * 1 second = 1000 milliseconds
 *
 * 5 seconds
 */
export const AUTO_SAVE_DELAY = 3 * 1000;
